var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1429 16.4286H4.85714C4.38571 16.4286 4 16.8143 4 17.2857C4 17.7571 4.38571 18.1429 4.85714 18.1429H19.1429C19.6143 18.1429 20 17.7571 20 17.2857C20 16.8143 19.6143 16.4286 19.1429 16.4286ZM19.1429 5H4.85714C4.38571 5 4 5.38571 4 5.85714C4 6.32857 4.38571 6.71429 4.85714 6.71429H19.1429C19.6143 6.71429 20 6.32857 20 5.85714C20 5.38571 19.6143 5 19.1429 5ZM19.1429 10.7143H4.85714C4.38571 10.7143 4 11.1 4 11.5714C4 12.0429 4.38571 12.4286 4.85714 12.4286H19.1429C19.6143 12.4286 20 12.0429 20 11.5714C20 11.1 19.6143 10.7143 19.1429 10.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon-hamburger.aeb833734378068302a34f2915bb7443.svg";
export { ForwardRef as ReactComponent };